module.exports = __webpack_public_path__ + "img/3Dian5_6.f6a10c2b.png";